import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { Ferie } from "../../core/model/ferie";
import { FerieService } from "../../core/service/ferie.service";

@Component({
  selector: "app-add-ferier",
  templateUrl: "./add-ferier.component.html",
  styleUrls: ["./add-ferier.component.scss"],
})
export class AddFerierComponent implements OnInit {
  fDate: any;
  ferie: Ferie = new Ferie();
  form2: FormGroup;
  pressButton: Boolean = false;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _ferieService: FerieService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      label: [null, Validators.compose([Validators.required])],
      ferieDate: [null, Validators.compose([Validators.nullValidator])],
    });
  }

  ngOnInit() {}

  save(): void {
    let month;
    month = this.fDate.month;
    if (this.fDate.month < 10) {
      month = "0" + this.fDate.month;
    }
    let day;
    day = this.fDate.day;
    if (this.fDate.day < 10) {
      day = "0" + this.fDate.day;
    }
    this.ferie.ferieDate = this.fDate.year + "-" + month + "-" + day;

    this.pressButton = true;
    this._ferieService
      .add(this.ferie)
      .pipe(first())
      .subscribe(
        (data) => {
          this.pressButton = false;
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
